<template>
  <v-layout align-start>
    <v-flex>
      <v-data-table :headers="headers" :items="roles" :search="search" class="elevation-1">
        <template v-slot:top>
          <v-toolbar color="white">
            <v-toolbar-title>Roles</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field
              class="text-xs-center"
              v-model="search"
              append-icon="search"
              label="Búsqueda"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="1000px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo</v-btn>
              </template>

              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field v-model="nombre" label="Nombre"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field v-model="descripcion" label="Descripción"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-select v-model="tipoid" :items="tiposelect" label="Tipo"></v-select>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" v-show="valida">
                        <v-row class="red--text" v-for="v in validamensaje" :key="v" v-text="v"></v-row>
                      </v-col>

                      <v-col cols="12" sm="3" md="3">
                        <v-switch
                          v-model="ingresadocumento"
                          label="Ingresa Documentos"
                          color="indigo darken-3"
                          hide-details
                        ></v-switch>
                      </v-col>

                      <v-col cols="12" sm="3" md="3">
                        <v-switch
                          v-model="canceladocumento"
                          label="Cancela Documentos"
                          color="indigo darken-3"
                          hide-details
                        ></v-switch>
                      </v-col>

                      <v-col cols="12" sm="3" md="3">
                        <v-switch
                          v-model="documentovigente"
                          label="Documento Vigente"
                          color="indigo darken-3"
                          hide-details
                        ></v-switch>
                      </v-col>

                      <v-col cols="12" sm="3" md="3">
                        <v-switch
                          v-model="documentovencido"
                          label="Documento Vencido"
                          color="indigo darken-3"
                          hide-details
                        ></v-switch>
                      </v-col>

                      <v-col cols="12" sm="3" md="3">
                        <v-switch
                          v-model="cuentadocumento"
                          label="Cuenta y Documento"
                          color="indigo darken-3"
                          hide-details
                        ></v-switch>
                      </v-col>

                      <v-col cols="12" sm="3" md="3">
                        <v-switch
                          v-model="verasignacion"
                          label="Ver Asignacion"
                          color="indigo darken-3"
                          hide-details
                        ></v-switch>
                      </v-col>

                      <v-col cols="12" sm="3" md="3">
                        <v-switch
                          v-model="crearrelacion"
                          label="Crear Relacion"
                          color="indigo darken-3"
                          hide-details
                        ></v-switch>
                      </v-col>

                      <v-col cols="12" sm="3" md="3">
                        <v-switch
                          v-model="verrelacion"
                          label="Ver Relacion"
                          color="indigo darken-3"
                          hide-details
                        ></v-switch>
                      </v-col>

                      <v-col cols="12" sm="3" md="3">
                        <v-switch
                          v-model="riesgocomun"
                          label="Riesgo Comun"
                          color="indigo darken-3"
                          hide-details
                        ></v-switch>
                      </v-col>

                      <v-col cols="12" sm="3" md="3">
                        <v-switch
                          v-model="verriesgocomun"
                          label="Ver Riesgo Comun"
                          color="indigo darken-3"
                          hide-details
                        ></v-switch>
                      </v-col>

                      <v-col cols="12" sm="3" md="3">
                        <v-switch v-model="rol" label="Rol" color="indigo darken-3" hide-details></v-switch>
                      </v-col>

                      <v-col cols="12" sm="3" md="3">
                        <v-switch
                          v-model="usuario"
                          label="Usuario"
                          color="indigo darken-3"
                          hide-details
                        ></v-switch>
                      </v-col>

                      <v-col cols="12" sm="3" md="3">
                        <v-switch
                          v-model="tipodocumento"
                          label="Tipo de Documento"
                          color="indigo darken-3"
                          hide-details
                        ></v-switch>
                      </v-col>

                      <v-col cols="12" sm="3" md="3">
                        <v-switch
                          v-model="tipooperacion"
                          label="Tipo de Operacion"
                          color="indigo darken-3"
                          hide-details
                        ></v-switch>
                      </v-col>

                      <v-col cols="12" sm="3" md="3">
                        <v-switch
                          v-model="caducidad"
                          label="Caducidad"
                          color="indigo darken-3"
                          hide-details
                        ></v-switch>
                      </v-col>

                      <v-col cols="12" sm="3" md="3">
                        <v-switch
                          v-model="tramite"
                          label="Tramite"
                          color="indigo darken-3"
                          hide-details
                        ></v-switch>
                      </v-col>

                      <v-col cols="12" sm="3" md="3">
                        <v-switch
                          v-model="parentesco"
                          label="Parentesco"
                          color="indigo darken-3"
                          hide-details
                        ></v-switch>
                      </v-col>

                      <v-col cols="12" sm="3" md="3">
                        <v-switch
                          v-model="relacion"
                          label="Relacion"
                          color="indigo darken-3"
                          hide-details
                        ></v-switch>
                      </v-col>

                      <v-col cols="12" sm="3" md="3">
                        <v-switch
                          v-model="acreditado"
                          label="Acreditado"
                          color="indigo darken-3"
                          hide-details
                        ></v-switch>
                      </v-col>

                      <v-col cols="12" sm="3" md="3">
                        <v-switch
                          v-model="cierre"
                          label="Cierre Diario"
                          color="indigo darken-3"
                          hide-details
                        ></v-switch>
                      </v-col>

                       <v-col cols="12" sm="3" md="3">
                        <v-switch
                          v-model="actualizaestatus"
                          label="Poner en Solicitud"
                          color="indigo darken-3"
                          hide-details
                        ></v-switch>
                      </v-col>
                       <v-col cols="12" sm="3" md="3">
                        <v-switch
                          v-model="mail"
                          label="Envio Correo"
                          color="indigo darken-3"
                          hide-details
                        ></v-switch>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                  <v-btn color="blue darken-1" text @click="guardar">Guardar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="adModal" max-width="290">
              <v-card>
                <v-card-title class="headline" v-if="adAccion==1">¿Activar Item?</v-card-title>
                <v-card-title class="headline" v-if="adAccion==2">¿Desactivar Item?</v-card-title>
                <v-card-text>
                  Estás a punto de
                  <span v-if="adAccion==1">Activar</span>
                  <span v-if="adAccion==2">Desactivar</span>
                  el ítem {{ adNombre }}
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="green darken-1" @click="activarDesactivarCerrar">Cancelar</v-btn>
                  <v-btn v-if="adAccion==1" color="orange darken-4" @click="activar">Activar</v-btn>
                  <v-btn v-if="adAccion==2" color="orange darken-4" @click="desactivar">Desactivar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.action="{ item }">
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-icon small class="mr-2" @click="editItem(item)" v-on="on">edit</v-icon>
            </template>
            <span>Editar Rol</span>
          </v-tooltip>

          <template v-if="item.condicion">
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-icon small class="mr-2" @click="ActivarDesactivarMostrar(2,item)" v-on="on">block</v-icon>
              </template>
              <span>Desactivar Rol</span>
            </v-tooltip>
          </template>
          <template v-else>
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-icon small class="mr-2" @click="ActivarDesactivarMostrar(1,item)" v-on="on">check</v-icon>
              </template>
              <span>Activar Rol</span>
            </v-tooltip>
          </template>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="listar">Reset</v-btn>
        </template>
        <template v-slot:item.condicion="{ item }">
          <v-chip :color="getColor(item.condicion)" dark v-if="item.condicion">ACTIVO</v-chip>
          <v-chip :color="getColor(item.condicion)" dark v-if="!item.condicion">SUSPENDIDO</v-chip>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      // Variable categoria
      roles: [],
      dialog: false,
      headers: [
        { text: "Actions", value: "action", sortable: false },
        { text: "Nombre", value: "nombre" },
        { text: "Descripcion", value: "descripcion" },
        { text: "Estado", value: "condicion", sortable: false }
      ],
      tipoid: "",
      tiposelect: [
        { text: "Administrador", value: 1 },
        { text: "Consulta", value: 2 },
        { text: "Captura", value: 3 },
        { text: "Supervisor", value: 4 }
      ],
      search: "",
      editedIndex: -1,
      //Declaracion de varaibles
      id: "",
      nombre: "",
      descripcion: "",
      // Declara variables de Validacion
      valida: 0,
      validamensaje: [],
      // Declara Varaiables para ctivar o desactivar categorias
      adModal: 0,
      adAccion: 0,
      adNombre: "",
      adId: "",
      documentovigente: false,
      documentovencido: false,
      ingresadocumento: false,
      canceladocumento: false,
      cuentadocumento: false,
      verasignacion: false,
      crearrelacion: false,
      verrelacion: false,
      riesgocomun: false,
      verriesgocomun: false,
      rol: false,
      usuario: false,
      tipodocumento: false,
      tipooperacion: false,
      caducidad: false,
      tramite: false,
      parentesco: false,
      relacion: false,
      acreditado: false,
      cierre: false,
      actualizaestatus:false,
      mail:false
    };
  },
  // Crea una nueva categoria si es -1
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nueva Rol" : "Actualizando Rol";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
    this.listar();
  },

  //
  methods: {
    // metodo listar
    listar() {
      // Variable para cargar los datos del api
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      // Manda llamar al listado e catalogos
      axios
        .get("api/roles/Listar", configuracion)
        .then(function(response) {
          // Bitacora
          axios
            .post(
              "api/Bitacoras/Crear",
              {
                socioid: 0,
                bitacoranombre: "ROL: LISTAR",
                usuarioid: me.$store.state.usuario.idusuario
              },
              configuracion
            )
            .then(function(response) {})
            .catch(function(error) {
              console.log(error);
              if (error.response.status === 401) {
                me.$swal("La Sesión a Expirado");
                me.$store.dispatch("salir");
              }
            });

          //console.log(response);
          me.roles = response.data;
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.status === 401) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    getColor(socioestatus) {
      if (socioestatus == true) return "#3F8103"; // Verde
      if (socioestatus == 14) return "orange";
      if (socioestatus == 1) return "yellow";
      if (socioestatus == false) return "#DA0707"; // Rojo
    },

    // Actualiza la categotia
    editItem(item) {
      this.id = item.idrol;
      this.nombre = item.nombre;
      this.descripcion = item.descripcion;
      this.editedIndex = 1;
      this.dialog = true;

      this.tipoid = item.tipoid;
      this.documentovigente = item.documentovigente;
      this.documentovencido = item.documentovencido;
      this.ingresadocumento = item.ingresadocumento;
      this.canceladocumento = item.canceladocumento;
      this.cuentadocumento = item.cuentadocumento;
      this.verasignacion = item.verasignacion;
      this.crearrelacion = item.crearrelacion;
      this.verrelacion = item.verrelacion;
      this.riesgocomun = item.riesgocomun;
      this.verriesgocomun = item.verriesgocomun;
      this.rol = item.roles;
      this.usuario = item.usuario;
      this.tipodocumento = item.tipodocumento;
      this.tipooperacion = item.tipooperacion;
      this.caducidad = item.caducidad;
      this.tramite = item.tramite;
      this.parentesco = item.parentesco;
      this.relacion = item.relacion;
      this.acreditado = item.acreditado;
      this.cierre = item.cierre;
      this.actualizaestatus=item.actualizaestatus;
      this.mail=item.mail;
    },

    deleteItem(item) {
      const index = this.desserts.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.desserts.splice(index, 1);
    },

    close() {
      this.dialog = false;
      this.limpiar();
    },

    limpiar() {
      this.id = "";
      this.nombre = "";
      this.descripcion = "";
      this.editedIndex = -1;

      this.tipoid = false;
      this.documentovigente = false;
      this.documentovencido = false;
      this.ingresadocumento = false;
      this.canceladocumento = false;
      this.cuentadocumento = false;
      this.verasignacion = false;
      this.crearrelacion = false;
      this.verrelacion = false;
      this.riesgocomun = false;
      this.verriesgocomun = false;
      this.rol = false;
      this.usuario = false;
      this.tipodocumento = false;
      this.tipooperacion = false;
      this.caducidad = false;
      this.tramite = false;
      this.parentesco = false;
      this.relacion = false;
      this.acreditado = false;
      this.cierre = false;
      this.actualizaestatus=false;
      this.mail=false;
    },

    guardar() {
      if (this.validar()) {
        return;
      }
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      if (this.editedIndex > -1) {
        //Editar
        let me = this;
        axios
          .put(
            "api/roles/Actualizar",
            {
              idrol: me.id,
              nombre: me.nombre,
              descripcion: me.descripcion,
              tipoid: me.tipoid,
              documentovigente: me.documentovigente,
              documentovencido: me.documentovencido,
              ingresadocumento: me.ingresadocumento,
              canceladocumento: me.canceladocumento,
              cuentadocumento: me.cuentadocumento,
              verasignacion: me.verasignacion,
              crearrelacion: me.crearrelacion,
              verrelacion: me.verrelacion,
              riesgocomun: me.riesgocomun,
              verriesgocomun: me.verriesgocomun,
              roles: me.rol,
              usuario: me.usuario,
              tipodocumento: me.tipodocumento,
              tipooperacion: me.tipooperacion,
              caducidad: me.caducidad,
              tramite: me.tramite,
              parentesco: me.parentesco,
              relacion: me.relacion,
              acreditado: me.acreditado,
              cierre: me.cierre,
              actualizaestatus:me.actualizaestatus,
              mail:me.mail
            },
            configuracion
          )
          .then(function(response) {
            // Bitacora
            axios
              .post(
                "api/Bitacoras/Crear",
                {
                  socioid: me.id,
                  bitacoranombre: "ROL: ACTUALIZAR",
                  usuarioid: me.$store.state.usuario.idusuario
                },
                configuracion
              )
              .then(function(response) {})
              .catch(function(error) {
                console.log(error);
                if (error.response.status === 401) {
                  me.$swal("La Sesión a Expirado");
                  me.$store.dispatch("salir");
                }
              });

            me.close();
            me.listar();
            me.limpiar();
            me.$swal("Rol Actualizado con Exito");
          })
          .catch(function(error) {
            console.log(error);
            if (error.response.status === 401) {
              me.$swal("La Sesión a Expirado");
              me.$store.dispatch("salir");
            }
          });
      } else {
        //Guardar
        let me = this;
        axios
          .post(
            "api/roles/Crear",
            {
              nombre: me.nombre,
              descripcion: me.descripcion,
              tipoid: me.tipoid,
              documentovigente: me.documentovigente,
              documentovencido: me.documentovencido,
              ingresadocumento: me.ingresadocumento,
              canceladocumento: me.canceladocumento,
              cuentadocumento: me.cuentadocumento,
              verasignacion: me.verasignacion,
              crearrelacion: me.crearrelacion,
              verrelacion: me.verrelacion,
              riesgocomun: me.riesgocomun,
              verriesgocomun: me.verriesgocomun,
              roles: me.rol,
              usuario: me.usuario,
              tipodocumento: me.tipodocumento,
              tipooperacion: me.tipooperacion,
              caducidad: me.caducidad,
              tramite: me.tramite,
              parentesco: me.parentesco,
              relacion: me.relacion,
              acreditado: me.acreditado,
              cierre: me.cierre,
              actualizaestatus:me.actualizaestatus,
              mail:me.mail
            },
            configuracion
          )
          .then(function(response) {
            // Bitacora
            axios
              .post(
                "api/Bitacoras/Crear",
                {
                  socioid: 0,
                  bitacoranombre: "ROL: GUARDAR",
                  usuarioid: me.$store.state.usuario.idusuario
                },
                configuracion
              )
              .then(function(response) {})
              .catch(function(error) {
                console.log(error);
                if (error.response.status === 401) {
                  me.$swal("La Sesión a Expirado");
                  me.$store.dispatch("salir");
                }
              });

            me.close();
            me.listar();
            me.limpiar();
            me.$swal("Rol Guardado con Exito");
          })
          .catch(function(error) {
            console.log(error);
            if (error.response.status === 401) {
              me.$swal("La Sesión a Expirado");
              me.$store.dispatch("salir");
            }
          });
      }
    },

    validar() {
      this.valida = 0;
      this.validamensaje = [];

      if (this.nombre.length < 3 || this.nombre.length > 50) {
        this.validamensaje.push(
          "El nombre debe tener más de 3 caracteres y menos de 30 caracteres"
        );
      }

      if (this.descripcion.length < 3 || this.nombre.length > 100) {
        this.validamensaje.push(
          "El nombre debe tener más de 3 caracteres y menos de 50 caracteres"
        );
      }
      if (this.validamensaje.length) {
        this.valida = 1;
      }
      return this.valida;
    },

    ActivarDesactivarMostrar(accion, item) {
      this.adModal = 1;
      this.adNombre = item.nombre;
      this.adId = item.idrol;
      if (accion == 1) {
        this.adAccion = 1;
      } else if (accion == 2) {
        this.adAccion = 2;
      } else {
        this.adModal = 0;
      }
    },
    activarDesactivarCerrar() {
      this.adModal = 0;
    },
    activar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put("api/roles/Activar/" + this.adId, {}, configuracion)
        .then(function(response) {
          // Bitacora
          axios
            .post(
              "api/Bitacoras/Crear",
              {
                socioid: me.adId,
                bitacoranombre: "ROL: ACTIVAR",
                usuarioid: me.$store.state.usuario.idusuario
              },
              configuracion
            )
            .then(function(response) {})
            .catch(function(error) {
              console.log(error);
              if (error.response.status === 401) {
                me.$swal("La Sesión a Expirado");
                me.$store.dispatch("salir");
              }
            });

          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar();
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.status === 401) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },
    desactivar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put("api/roles/Desactivar/" + this.adId, {}, configuracion)
        .then(function(response) {
          // Bitacora
          axios
            .post(
              "api/Bitacoras/Crear",
              {
                socioid: me.adId,
                bitacoranombre: "ROL: SUSPENDER",
                usuarioid: me.$store.state.usuario.idusuario
              },
              configuracion
            )
            .then(function(response) {})
            .catch(function(error) {
              console.log(error);
              if (error.response.status === 401) {
                me.$swal("La Sesión a Expirado");
                me.$store.dispatch("salir");
              }
            });

          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar();
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.status === 401) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    }
  }
};
</script>